<template>
  <v-container class="pa-0">
    <v-row align="center" no-gutters>
      <span class="text-subtitle-1 font-weight-light mr-1">Preset profile</span>
      <v-divider></v-divider>
    </v-row>

    <v-col class="text-center mt-8">
      <div class="no-profile-container">
        <v-icon size="100px" color="primary">mdi-bookmark-remove</v-icon>
        <h2 class="text-h5 font-weight-light mt-3 mb-2">No Profile Selected</h2>
        <p class="text-body-1 text--secondary">
          Please select a profile to continue
        </p>
      </div>
    </v-col>
  </v-container>
</template>

<script>
export default {
  name: "NoProfileSelected",
};
</script>

<style scoped>
.no-profile-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
}
</style>
  
  
  